import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

const ErrorDialog = ({ open, onClose, errorDetails, isDark, isMobile }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
    >
      <DialogTitle sx={{
        bgcolor: errorDetails.errorType === 'BALANCE_RECORDING_FAILED' || errorDetails.errorType === 'NODE_UNREACHABLE'
          ? 'warning.main' : 'error.main',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}>
        {errorDetails.title || 'Error'}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {errorDetails.message}
        </Typography>
        {errorDetails.technicalDetails && errorDetails.technicalDetails !== errorDetails.message && (
          <Typography variant="body2" sx={{
            color: 'text.secondary',
            bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
            border: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            p: 1.5,
            borderRadius: 1,
            fontFamily: 'monospace',
            fontSize: '0.8rem',
            wordBreak: 'break-word',
          }}>
            {errorDetails.technicalDetails}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
